import React, { useEffect, useState } from "react";
import {
  Box,
  Stack,
  Typography,
  Button,
  CircularProgress,
  TextField,
} from "@mui/material";
import toast from "react-hot-toast";
import axios from "axios";
import { URL } from "../config";

const StatusModal = ({ onClose, status }) => {
  const [statusName, setStatusName] = useState(status?.statusName || "");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setStatusName(status?.statusName || "");
  }, [status]);

  const handleSubmit = async () => {
    if (!statusName.trim()) {
      toast.error("Please enter status name!");
      return;
    }

    setLoading(true);
    try {
      if (status) {
        await axios.patch(`${URL}/statuses/${status.statusId}`, {
          statusName,
        });
        toast.success("Status updated successfully!");
      } else {
        await axios.post(`${URL}/statuses`, { statusName });
        toast.success("Status added successfully!");
      }
      setTimeout(() => onClose?.(), 500);
    } catch (err) {
      toast.error("Operation failed!");
    } finally {
      setLoading(false);
    }
  };

  const fieldStyle = {
    "& .MuiOutlinedInput-root": {
      minHeight: "28px",
      fontSize: "14px",
      "& fieldset": { borderColor: "#c4c4c4" },
      "&:hover fieldset": { borderColor: "#184459ff" },
      "&.Mui-focused fieldset": {
        borderColor: "#c4c4c4",
        borderWidth: "1.5px",
      },
    },
    "& .MuiInputLabel-root": {
      fontSize: "18px",
      color: "#184459ff",
      fontWeight: 600,
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "#184459ff",
    },
  };

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        bgcolor: "rgba(0,0,0,0.6)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1300,
        p: 2,
      }}
    >
      <Box
        sx={{
          width: { xs: "90%", sm: 400 },
          bgcolor: "#fff",
          borderRadius: 2,
          p: 3,
        }}
      >
        <Typography
          variant="h6"
          sx={{ textAlign: "center", color: "#184459ff", mb: 2 }}
        >
          {status ? "Edit Status" : "Add Status"}
        </Typography>

        <Stack spacing={2}>
          <TextField
            fullWidth
            label="Status Name"
            size="small"
            value={statusName}
            onChange={(e) => setStatusName(e.target.value)}
            sx={fieldStyle}
            InputLabelProps={{ shrink: true }}
          />

          <Stack direction="row" spacing={1} justifyContent="flex-end">
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#184459ff",
                "&:hover": { backgroundColor: "#184459ff" },
              }}
              onClick={handleSubmit}
              startIcon={loading && <CircularProgress size={18} />}
            >
              {loading ? "Saving..." : status ? "Update" : "Save"}
            </Button>

            <Button
              variant="contained"
              sx={{
                backgroundColor: "#757575ff",
                "&:hover": { backgroundColor: "#757575ff" },
              }}
              onClick={onClose}
            >
              Close
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
};

export default StatusModal;
